"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FRAGMENT_IDENTIFIERS = exports.CHECKOUT_IDS = exports.DEVIATION_PATHS = exports.USER_PROFILE_POSTS_SUB_PATHS = exports.USER_PROFILE_SHOP_SUB_PATHS = exports.USER_PROFILE_SECTION_PATHS = exports.PROJECTS = exports.URLS = void 0;
// These are production canonical URLs
var URLS;
(function (URLS) {
    URLS["ROOT"] = "https://www.deviantart.com";
    // the following are non-node URLs
    URLS["ABOUT"] = "https://www.deviantart.com/about";
    URLS["ADVERTISE"] = "https://deviantartads.com";
    URLS["CAREERS"] = "https://www.deviantart.com/team/journal/Careers-at-DeviantArt-855261915";
    URLS["CART"] = "https://www.deviantart.com/checkout/";
    URLS["COMMISSIONS"] = "https://www.deviantart.com/commissions";
    URLS["CONTACT"] = "https://www.deviantartsupport.com/en/article/how-do-i-contact-deviantart";
    URLS["COPYRIGHT"] = "https://www.deviantart.com/about/policy/copyright/";
    URLS["COPYRIGHT_POLICY"] = "https://www.deviantartsupport.com/en/article/the-copyright-policy";
    URLS["CORE_MEMBERSHIP"] = "https://www.deviantart.com/core-membership";
    URLS["CORE_MEMBERSHIP_LOUNGE_SECTION"] = "https://www.deviantart.com/core-membership#core-lounge";
    URLS["DEVELOPERS"] = "https://www.deviantart.com/developers";
    URLS["EARNINGS"] = "https://www.deviantart.com/account/earnings/";
    URLS["EARNINGS_DOWNLOAD"] = "https://www.deviantart.com/account/earnings/download_csv/";
    URLS["ETIQUETTE"] = "https://www.deviantart.com/about/policy/etiquette";
    URLS["FEEDBACK"] = "https://www.deviantartsupport.com/en/eclipse";
    URLS["FORUM"] = "https://www.deviantart.com/forum";
    URLS["GROUPS"] = "https://www.deviantart.com/groups";
    URLS["HELP"] = "https://www.deviantartsupport.com/en/";
    URLS["HELP_NEW_TICKET"] = "https://contact.deviantartsupport.com/en";
    URLS["LOGOUT"] = "https://www.deviantart.com/users/logout";
    URLS["MLT"] = "https://www.deviantart.com/morelikethis";
    URLS["NOTES"] = "https://www.deviantart.com/notifications/notes";
    URLS["OAUTH_AUTHORIZE"] = "https://www.deviantart.com/oauth2/authorize";
    URLS["ORDERS"] = "https://www.deviantart.com/account/";
    URLS["POINTS"] = "https://www.deviantart.com/account/points/";
    URLS["ABOUT_POINTS"] = "https://www.deviantartsupport.com/en/article/what-are-points-1749105";
    URLS["POLLS"] = "https://www.deviantart.com/polls";
    URLS["PRINTS_POLICY"] = "https://www.deviantart.com/about/policy/prints/agreement/";
    URLS["PRINTS_PRICES"] = "https://www.deviantartsupport.com/en/article/what-are-the-base-prices-for-prints";
    URLS["PRINTS_HOWTO"] = "https://www.deviantartsupport.com/en/article/how-do-i-submit-my-deviation-as-a-print";
    URLS["PRIVACY"] = "https://www.deviantart.com/about/policy/privacy";
    URLS["SETTINGS"] = "https://www.deviantart.com/settings/identity";
    URLS["SETTINGS_GENERAL"] = "https://www.deviantart.com/settings/general";
    URLS["SETTINGS_BILLING"] = "https://www.deviantart.com/settings/billing_and_payments";
    URLS["SETTINGS_REBILLING"] = "https://www.deviantart.com/settings/rebilling";
    URLS["SETTINGS_SUBSCRIPTIONS"] = "https://www.deviantart.com/settings/subscriptions";
    URLS["SHOP"] = "https://www.deviantart.com/shop";
    URLS["STASH"] = "https://sta.sh/";
    URLS["STATUS_UPDATES"] = "https://www.deviantart.com/status-updates";
    URLS["SUBMISSION_POLICY"] = "https://www.deviantart.com/about/policy/submission";
    URLS["SUBMIT"] = "https://www.deviantart.com/submit/";
    URLS["SUBMIT_MURO"] = "https://www.deviantart.com/muro/";
    URLS["TAG"] = "https://www.deviantart.com/tag";
    URLS["TOS"] = "https://www.deviantart.com/about/policy/service";
    URLS["PREMIUM_TOS"] = "https://www.deviantart.com/about/policy/premium_content_terms_of_service/";
    URLS["WATCHING"] = "https://www.deviantart.com/watching/";
    URLS["CHAT_HOME"] = "https://www.deviantart.com/chat";
    URLS["CDN"] = "https://st.deviantart.net";
    URLS["ART_STORE"] = "https://www.popup-art.shop/";
    URLS["DMCA"] = "https://contact.deviantartsupport.com/en?subOptionId=I-am-the-Copyright-holder.41656";
    URLS["DMCA_COUNTER"] = "https://contact.deviantartsupport.com/en?subOptionId=I%27d-like-to-file-a-counter-DMCA61640";
    URLS["CUSTOMER_DASHBOARD"] = "https://www.deviantart.com/account/customers";
    URLS["CHECKOUT_ERRORS"] = "https://www.deviantartsupport.com/en/article/why-am-i-getting-an-issue-notification-when-i-try-to-purchase";
    URLS["PROTECT"] = "https://www.deviantartprotect.com/";
    URLS["TEAM"] = "https://www.deviantart.com/team";
})(URLS = exports.URLS || (exports.URLS = {}));
var PROJECTS;
(function (PROJECTS) {
    PROJECTS["BROWSE"] = "BROWSE";
    PROJECTS["MESSAGECENTRE"] = "MESSAGECENTRE";
    PROJECTS["PROFILE"] = "PROFILE";
    PROJECTS["DEVIATION"] = "DEVIATION";
    PROJECTS["COMMENTS"] = "COMMENTS";
    PROJECTS["SISU"] = "SISU";
    PROJECTS["PONIES"] = "PONIES";
    PROJECTS["CHAT"] = "CHAT";
    PROJECTS["EDITOR"] = "EDITOR";
    PROJECTS["FEEDBACK"] = "FEEDBACK";
    PROJECTS["STASH"] = "STASH";
})(PROJECTS = exports.PROJECTS || (exports.PROJECTS = {}));
var USER_PROFILE_SECTION_PATHS;
(function (USER_PROFILE_SECTION_PATHS) {
    USER_PROFILE_SECTION_PATHS["HOME"] = "";
    USER_PROFILE_SECTION_PATHS["ABOUT"] = "about";
    USER_PROFILE_SECTION_PATHS["GALLERY"] = "gallery";
    USER_PROFILE_SECTION_PATHS["SHOP"] = "shop";
    USER_PROFILE_SECTION_PATHS["FAVOURITES"] = "favourites";
    USER_PROFILE_SECTION_PATHS["POSTS"] = "posts";
    USER_PROFILE_SECTION_PATHS["STATS"] = "stats";
    USER_PROFILE_SECTION_PATHS["SUBSCRIPTIONS"] = "subscriptions";
})(USER_PROFILE_SECTION_PATHS = exports.USER_PROFILE_SECTION_PATHS || (exports.USER_PROFILE_SECTION_PATHS = {}));
var USER_PROFILE_SHOP_SUB_PATHS;
(function (USER_PROFILE_SHOP_SUB_PATHS) {
    USER_PROFILE_SHOP_SUB_PATHS["ALL"] = "";
    USER_PROFILE_SHOP_SUB_PATHS["COMMISSIONS"] = "commissions";
    USER_PROFILE_SHOP_SUB_PATHS["PRINTS"] = "prints";
    USER_PROFILE_SHOP_SUB_PATHS["PREMIUM_CONTENT"] = "premium_content";
    USER_PROFILE_SHOP_SUB_PATHS["PREMIUM_FOLDERS"] = "premium_folders";
})(USER_PROFILE_SHOP_SUB_PATHS = exports.USER_PROFILE_SHOP_SUB_PATHS || (exports.USER_PROFILE_SHOP_SUB_PATHS = {}));
var USER_PROFILE_POSTS_SUB_PATHS;
(function (USER_PROFILE_POSTS_SUB_PATHS) {
    USER_PROFILE_POSTS_SUB_PATHS["ALL"] = "";
    USER_PROFILE_POSTS_SUB_PATHS["JOURNALS"] = "journals";
    USER_PROFILE_POSTS_SUB_PATHS["STATUSES"] = "statuses";
    USER_PROFILE_POSTS_SUB_PATHS["POLLS"] = "polls";
    USER_PROFILE_POSTS_SUB_PATHS["DRAFTS"] = "drafts";
})(USER_PROFILE_POSTS_SUB_PATHS = exports.USER_PROFILE_POSTS_SUB_PATHS || (exports.USER_PROFILE_POSTS_SUB_PATHS = {}));
var DEVIATION_PATHS;
(function (DEVIATION_PATHS) {
    DEVIATION_PATHS["DEVIATION"] = "art";
    DEVIATION_PATHS["JOURNAL"] = "journal";
    DEVIATION_PATHS["COMMISSION"] = "commission";
    DEVIATION_PATHS["STATUS"] = "status-update";
    DEVIATION_PATHS["POLL"] = "poll";
    DEVIATION_PATHS["TIER"] = "tier";
})(DEVIATION_PATHS = exports.DEVIATION_PATHS || (exports.DEVIATION_PATHS = {}));
var CHECKOUT_IDS;
(function (CHECKOUT_IDS) {
    CHECKOUT_IDS[CHECKOUT_IDS["CAKE"] = 150647560] = "CAKE";
})(CHECKOUT_IDS = exports.CHECKOUT_IDS || (exports.CHECKOUT_IDS = {}));
var FRAGMENT_IDENTIFIERS;
(function (FRAGMENT_IDENTIFIERS) {
    FRAGMENT_IDENTIFIERS["CORE_PICKER_LOUNGE_SECTION"] = "core-lounge";
})(FRAGMENT_IDENTIFIERS = exports.FRAGMENT_IDENTIFIERS || (exports.FRAGMENT_IDENTIFIERS = {}));
//# sourceMappingURL=constants.js.map